module.exports = __webpack_public_path__ + "static/media/worldsick.f47b24f0.svg";